export const getSessionControlState = ({
  isHubConnected,
  isConnecting,
  sessionStarted,
  goNext,
}) => ({
  canConnect: !isHubConnected && !isConnecting,
  canStart: isHubConnected && !sessionStarted && !goNext,
  canDisconnect: isHubConnected,
  canStop: sessionStarted,
  canGoNext: goNext,
});
